/* tslint:disable */
/* eslint-disable */
/**
 * Search API
 * Search
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const SourcingSearchFormerEmployerActivityArea = {
    AviationAerospace: 'AVIATION_AEROSPACE',
    It: 'IT',
    Food: 'FOOD',
    Architecture: 'ARCHITECTURE',
    Crafts: 'CRAFTS',
    CivicSocial: 'CIVIC_SOCIAL',
    Automobile: 'AUTOMOBILE',
    BankingInsurance: 'BANKING_INSURANCE',
    Biotech: 'BIOTECH',
    CivilEngineering: 'CIVIL_ENGINEERING',
    Research: 'RESEARCH',
    Chemical: 'CHEMICAL',
    Film: 'FILM',
    SmallRetail: 'SMALL_RETAIL',
    Consulting: 'CONSULTING',
    Culture: 'CULTURE',
    Military: 'MILITARY',
    Leisure: 'LEISURE',
    ECommerce: 'E_COMMERCE',
    Publishing: 'PUBLISHING',
    Education: 'EDUCATION',
    Software: 'SOFTWARE',
    Energy: 'ENERGY',
    Environment: 'ENVIRONMENT',
    Retail: 'RETAIL',
    HighTech: 'HIGH_TECH',
    Hospitality: 'HOSPITALITY',
    RealEstate: 'REAL_ESTATE',
    ImportExport: 'IMPORT_EXPORT',
    Mechanical: 'MECHANICAL',
    Primary: 'PRIMARY',
    Pharma: 'PHARMA',
    Games: 'GAMES',
    Luxury: 'LUXURY',
    Cosmetics: 'COSMETICS',
    Nanotech: 'NANOTECH',
    Iot: 'IOT',
    Press: 'PRESS',
    Social: 'SOCIAL',
    Hr: 'HR',
    Restaurants: 'RESTAURANTS',
    Health: 'HEALTH',
    Medical: 'MEDICAL',
    Public: 'PUBLIC',
    Safety: 'SAFETY',
    Sports: 'SPORTS',
    Telecom: 'TELECOM',
    Transport: 'TRANSPORT',
    Logistic: 'LOGISTIC',
    Travel: 'TRAVEL',
    Wine: 'WINE',
    Legal: 'LEGAL',
    PrivateEquity: 'PRIVATE_EQUITY'
} as const;
export type SourcingSearchFormerEmployerActivityArea = typeof SourcingSearchFormerEmployerActivityArea[keyof typeof SourcingSearchFormerEmployerActivityArea];


export function instanceOfSourcingSearchFormerEmployerActivityArea(value: any): boolean {
    for (const key in SourcingSearchFormerEmployerActivityArea) {
        if (Object.prototype.hasOwnProperty.call(SourcingSearchFormerEmployerActivityArea, key)) {
            // @ts-ignore
            if (SourcingSearchFormerEmployerActivityArea[key] === value) {
                return true;
            }
        }
    }
    return false;
}

export function SourcingSearchFormerEmployerActivityAreaFromJSON(json: any): SourcingSearchFormerEmployerActivityArea {
    return SourcingSearchFormerEmployerActivityAreaFromJSONTyped(json, false);
}

export function SourcingSearchFormerEmployerActivityAreaFromJSONTyped(json: any, ignoreDiscriminator: boolean): SourcingSearchFormerEmployerActivityArea {
    return json as SourcingSearchFormerEmployerActivityArea;
}

export function SourcingSearchFormerEmployerActivityAreaToJSON(value?: SourcingSearchFormerEmployerActivityArea | null): any {
    return value as any;
}

